export default [
  {
    path: '/repayOrder',
    name: 'RepayOrder',
    component: () => import('@/views/repay/index.vue')
  },
  {
    path: '/orderDetails',
    name: 'OrderDetails',
    component: () => import('@/views/repay/orderDetails.vue')
  },
  {
    path: '/repayMethod',
    name: 'RepayMethod',
    component: () => import('@/views/repay/repayMethod.vue')
  },
  {
    path: '/extensionMethod',
    name: 'ExtensionMethod',
    component: () => import('@/views/repay/extensionMethod.vue')
  },
  {
    path: '/payDetails',
    name: 'PayDetails',
    component: () => import('@/views/repay/payDetails.vue')
  }
]
